import type { Severity } from '../types';

/**
 * Process toast events from webview
 */
export const webViewToastMessageExecutor = ({ payload }: { payload: { title: string; severity: Severity } }) => {
  // eslint-disable-next-line no-console -- temp before accessing the toast api
  console.info(`\x1b[33m[WEB VIEW TOAST]\x1b[0m: ${JSON.stringify(payload)}`);
};
